import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import  { Amplify,Auth, API } from 'aws-amplify';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Observable } from "rxjs";
import { map, catchError } from 'rxjs/operators';

import { environment } from '../../environments/environment';


export interface IUser {
  email: string;
  password: string;
  showPassword: boolean;
  code: string;
  name: string;
}
export interface signUpUser {
  email: string;
  password: string;
  phone: string;
  code: string;
  name: string;
  tenantId: string | undefined;
  group: string;
}

@Injectable({
  providedIn: 'root',
})
export class CognitoService {
  userdata: any;
  private authenticationSubject: BehaviorSubject<any>;

  constructor(private http: HttpClient) {
    Amplify.configure({
      Auth: environment.aws,
    });

    this.authenticationSubject = new BehaviorSubject<boolean>(false);
  }

  public signUp(user: signUpUser): Promise<any> {
    console.log(user.tenantId)
    return Auth.signUp({
      username: user.name,
      password: user.password,
      //Permanent:false,
      attributes: {
        email: user.email,
        'custom:tenantId': user.tenantId,
        phone_number: user.phone,
        'custom:group': user.group  // optional - E.164 number convention
        // other custom attributes
      },

     /* autoSignIn: { // optional - enables auto sign in after user is confirmed
        enabled: false,
      }*/
    });
  }

  public forgotPassword(user: IUser): Promise<any> {  
    return Auth.forgotPassword(user.email);
  }
  public forgotPasswordSubmit(user: IUser): Promise<any> {
    return Auth.forgotPasswordSubmit(user.email, user.code, user.password);
  }

  public confirmSignUp(user: IUser): Promise<any> {
    return Auth.confirmSignUp(user.email, user.code);
  }

  async signIn(user: IUser) {
    const userdata = await Auth.signIn(user.email, user.password);
    this.userdata = userdata
    console.log(userdata);

    return userdata

  }

  /* public  signIn(user: IUser) : Promise<any> {
     return Auth.signIn(user.email, user.password);
 }*/
  async confirmSignIn(user: IUser) {
    console.log(user);

    if (this.userdata.challengeName === 'SMS_MFA') {
      // You need to get the code from the UI inputs
      // and then trigger the following function with a button click
      const mfaType = 'SMS_MFA';
      const code = user.code.toString();
      // If MFA is enabled, sign-in should be confirmed with the confirmation code
      const loggedUser = await Auth.confirmSignIn(
        this.userdata, // Return object from Auth.signIn()
        code, // Confirmation code
        mfaType // MFA Type e.g. SMS_MFA, SOFTWARE_TOKEN_MFA
      );
      if (loggedUser != null) {
        loggedUser.getSession((err: any, session: any) => {
          if (err) {
            alert(err.message || JSON.stringify(err));
            return;
          }
          else {
            sessionStorage.setItem("currentUserGroups", session.getIdToken().payload['cognito:groups']);
            console.log(session.getIdToken().payload['cognito:groups']);
          }

          // assigning auth status inside the callback
        })
      }
      console.log(loggedUser);
      return loggedUser

    }
  }


  public signOut(): Promise<any> {
    return Auth.signOut()
      .then(() => {
        this.authenticationSubject.next(false);
        localStorage.removeItem('careTEamIDLocal');

      });
  }

  async isAuthenticated(): Promise<boolean> {
    if (this.authenticationSubject.value) {
      return Promise.resolve(true);
    } else {
      console.log(this.getUser())
      return this.getUser()
        .then((user: any) => {
          if (user) {
            return true;
          } else {
            return false;
          }
        }).catch(() => {
          return false;
        });
    }
  }

  public getUser(): Promise<any> {
    return Auth.currentUserInfo();
  }

  async updateUser(user: IUser): Promise<any> {
    return Auth.currentUserPoolUser()
      .then((cognitoUser: any) => {
        return Auth.updateUserAttributes(cognitoUser, user);
      });
  }

  async getUserAuthorization(): Promise<any> {
    const auth = (await Auth.currentSession()).getIdToken().getJwtToken();
    // console.log(auth)
    const sub = (await Auth.currentSession()).getIdToken().payload['sub'];
    // console.log (sub)
    const authdata = {
      token: auth,
      sub: sub
    };
    //console.log(authdata)
    return authdata
  }
  async GetFHIRAuthorizationHeaders() {
    const authData = await this.getUserAuthorization();
    if (authData != null) {
      const customHeaders: HeadersInit = {
        "Content-Type": "application/fhir+json",
        "X-Requested-With": 'XMLHttpRequest',
        "Authorization": authData.token,
        "authorizationType": "AMAZON_COGNITO_USER_POOLS",
        "derived-from": authData.sub,
        //"derived-from":"3e2b2721-2707-47b8-a733-97afa8169d4e",
        "region": "AP-SOUTH-01",
        "endpointType": "REST",
      }
      return customHeaders;
    } else {
      return undefined;
    }
  }

 


}
